import Grid from '@mui/material/Grid2';
import type { Control, UseFormHandleSubmit } from 'react-hook-form';
import { LeftColumnSkeleton } from '../Skeletons';
import AssociatedRecordsPanel from './components/AssociatedRecordsPanel';
import NotesPanel from './components/NotesPanel';

type Note = {
  id: number;
  description: string;
  created_at: string;
};

type AssociatedRecord = {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  external_id?: string;
  phone_number1: string;
  phone_number2?: string;
  phone_number3?: string;
  dob?: string;
  created_at?: string;
  updated_at?: string;
};

interface FormValues {
  contact: { call: number | string; [key: string]: unknown };
  note: { description: string };
}

export default function InteractionLogMiddleColumn({
  isLoading,
  middleColumnSx,
  associatedRecords,
  notes,
  formatNoteDate,
  control,
  handleSubmit,
  editingNote,
  handleEditClick,
  deleteNote,
  handleCreateOrUpdateNote,
  isCreatePending,
  isUpdatePending
}: {
  isLoading: boolean;
  middleColumnSx: object;
  associatedRecords?: { integration_entity_contacts?: AssociatedRecord[] };
  notes?: { data: Note[] };
  formatNoteDate: (date: string) => string;
  control: Control<FormValues>;
  handleSubmit: UseFormHandleSubmit<FormValues>;
  editingNote: number | null;
  handleEditClick: (note: { id: number; description: string }) => void;
  deleteNote: (id: number) => void;
  handleCreateOrUpdateNote: (data: { note: { description: string } }) => Promise<void>;
  isCreatePending: boolean;
  isUpdatePending: boolean;
}) {
  return (
    <Grid size={{ xs: 12, lg: 4 }} sx={middleColumnSx}>
      {isLoading ? (
        <LeftColumnSkeleton />
      ) : (
        <>
          <AssociatedRecordsPanel associatedRecords={associatedRecords} formatDate={formatNoteDate} />
          <NotesPanel
            notes={notes}
            formatNoteDate={formatNoteDate}
            control={control}
            handleSubmit={handleSubmit}
            editingNote={editingNote}
            onEditClick={handleEditClick}
            onDelete={deleteNote}
            onSubmit={handleCreateOrUpdateNote}
            isPending={isCreatePending || isUpdatePending}
          />
        </>
      )}
    </Grid>
  );
}
